<template>
    <div class="Experience">
        <Section/>
    </div>
</template>

<script>

import Section from '@/components/Section.vue'

export default {
    name: 'Experience',
    components: { Section },
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Experience
    display block
    position absolute
    top 0
    left 0
    width 100vw
    height 100vh

</style>




